import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { kbAPI } from '../../services/(adminapi)/kbAPI'

// Async thunks
export const fetchKBSources = createAsyncThunk(
  'kb/fetchKBSources',
  async (_, { rejectWithValue }) => {
    try {
      const response = await kbAPI.getKBSources()
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch KB sources')
    }
  }
)

export const deleteKBSource = createAsyncThunk(
  'kb/deleteKBSource',
  async (sourceId, { rejectWithValue }) => {
    try {
      const response = await kbAPI.deleteKBSource(sourceId)
      return { sourceId, response }
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to delete KB source')
    }
  }
)

export const uploadKBFile = createAsyncThunk(
  'kb/uploadKBFile',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await kbAPI.uploadFile(formData)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to upload file')
    }
  }
)

const initialState = {
  kbSources: [],
  loading: false,
  uploading: false,
  error: null,
  success: null
}

const kbSlice = createSlice({
  name: 'kb',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearSuccess: (state) => {
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch KB sources
      .addCase(fetchKBSources.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchKBSources.fulfilled, (state, action) => {
        state.loading = false
        if (action.payload.success) {
          state.kbSources = action.payload.data || []
        }
        state.error = null
      })
      .addCase(fetchKBSources.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.kbSources = []
      })
      
      // Delete KB source
      .addCase(deleteKBSource.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(deleteKBSource.fulfilled, (state, action) => {
        state.loading = false
        state.kbSources = state.kbSources.filter(source => source._id !== action.payload.sourceId)
        state.success = 'KB source deleted successfully'
      })
      .addCase(deleteKBSource.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      // Upload KB file
      .addCase(uploadKBFile.pending, (state) => {
        state.uploading = true
        state.error = null
        state.success = null
      })
      .addCase(uploadKBFile.fulfilled, (state, action) => {
        state.uploading = false
        if (action.payload.success) {
          state.success = 'File uploaded successfully'
          // Optionally refresh the list
        }
        state.error = null
      })
      .addCase(uploadKBFile.rejected, (state, action) => {
        state.uploading = false
        state.error = action.payload
      })
  }
})

export const { clearError, clearSuccess } = kbSlice.actions
export default kbSlice.reducer

